<template>
  <div :style="style()" />
</template>
<script>
import { BsGetEnv, BsUtil } from 'dida-web-common'
export default {
    name: 'HermesV10Fitter',
    props: {
        editableData: {
            type: Object,
            default: function() {
                return {
                    basic: {}
                }
            }
        }
    },
    data() {
        return {
            isV10: BsGetEnv.inApplication && BsUtil.compareVersion(BsGetEnv.curAppVersion, '10.0.0') >= 0
        }
    },
    methods: {
        style() {
            if (this.isV10) {
                return {
                    height: this.editableData.basic.height + 'px'
                }
            } else {
                return {
                    height: '0'
                }
            }
        }
    }
}
</script>

<style lang="scss">
    @import '../webp.scss';
    .mars-image{
        width: 100%;
        height: 100%;
        display: block;
    }
</style>
